module.exports = __webpack_public_path__ + "img/DIO2000&3000.dd6567ca.png";